import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'privacy-policy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
